<button class="mobile-menu-toggler ml-n2" (click)="toggleMenu($event)">
    <span class="sr-only">Toggle mobile menu</span>
    <i class="icon-bars"></i>
</button>